//Libs
import React from "react";
import useTheme from "hooks/useTheme";
//Components
import SmallIcon from "./SmallIcon";

const ICON_HEIGHT = { small: 16, normal: 24, medium: 32, large: 50, xLarge: 66 };

const SelectedIcon = ({ size, fill }) => {
  if (size === 'small') return <SmallIcon fill={fill} />;
  return null;
};

const InfoIcon = ({ size, selected, hoverable }) => {
  const { theme } = useTheme();
  const [hover, setHover] = React.useState(false);

  const fill = React.useMemo(
    () =>
      hover || selected ? theme._secondaryColor : theme._highEmphasisColor,
    [hover, selected, theme]
  );

  return (
    <div
      style={{ height: ICON_HEIGHT[size] || 24 }}
      onMouseEnter={() => hoverable && setHover(true)}
      onMouseLeave={() => hoverable && setHover(false)}
    >
      <SelectedIcon size={size} fill={fill} />
    </div>
  );
};

export default InfoIcon;
